import type { SiteLocationsResponse } from '../../models/entities/site-location.model';
import type { SiteStats } from '../../models/entities/site-stats.model';
import type { DisarmSiteResponse } from '../../models/entities/site-arm-disarm.model';
import type { ApiEndpointDefinition } from '../api-endpoint.types';

export const SITE_ENDPOINTS = {
  siteArmed: {
    id: 'site-armed',
    method: 'GET',
    apiPath: '/api/dealer/sites/armed',
    page: 'events',
    entity: 'site-armed',
  } satisfies ApiEndpointDefinition<SiteLocationsResponse>,
  siteDisarmed: {
    id: 'site-disarmed',
    method: 'GET',
    apiPath: '/api/dealer/sites/disarmed',
    page: 'events',
    entity: 'site-disarmed',
  } satisfies ApiEndpointDefinition<SiteLocationsResponse>,
  siteDisarm: {
    id: 'site-disarm',
    method: 'POST',
    apiPath: '/api/dealer/sites/:siteId/disarm',
    page: 'events',
    entity: 'site-disarm',
  } satisfies ApiEndpointDefinition<DisarmSiteResponse>,
} as const satisfies Record<string, ApiEndpointDefinition>;
